/**
 * Created by zhaoyao on 2021/6/3
 * Desc: 信息服务费缴费
 */

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Avatar } from 'antd'
import { Toast } from 'antd-mobile'
import { getSearchParams, isObjEmpty } from '../../utils/common'
import './ServicePayCost.css'
import { fetchGet, fetchPost } from '../../utils/fetchRequest'
import { API } from '../../configs/api.config'
import { switchUser } from 'action/userInfo'

class ServicePayCost extends Component {

    constructor(props) {
        super(props)

        this.state = {
            id: this.props.match.params.id,
            appId: this.props.match.params.appId,
            openId: this.props.match.params.openId,
            schoolId: this.props.match.params.schoolId,
            balance: '0',
            payment: '0',
            createDate: '',
            rechargeList: [],
            errorMsg: '',
        }
    }

    componentDidMount() {
        document.title = '信息服务费'

        Toast.loading('', 0)
        this.getServiceList()
    }

    componentWillUnmount() {
        Toast.hide()
    }

    render() {
        const {
            balance,
            payment,
            createDate,
            rechargeList,
            schoolContent, schoolExplain
        } = this.state

        const rechargeItems = []
        rechargeList.forEach((rechargeObj, index) => {
            rechargeItems.push(<div className='service-content-layout1'>
                <div
                    className='service-content-item'
                    onClick={this.onRechargeClick.bind(this, index,
                        rechargeObj.id)}>
                    <span
                        className='service-content-item-text'>{rechargeObj.yearsMany}</span>
                    <span
                        className='service-content-item-text'>¥ {rechargeObj.amount}</span>
                </div>
                {/*}*/}
            </div>)
        })

        return (
            <div id='info-service-root'>

                <div id='info-service-body'>
                    {/*服务内容*/}
                    <span className='service-content-title'>服务内容</span>
                    {/*<span id='body-service-content'>{userInfo.parent.schoolContent}</span>*/}
                    <span id='body-service-content'><div dangerouslySetInnerHTML={{ __html: schoolContent }} /></span>

                    {/*服务说明*/}
                    <span className='service-content-title'>服务说明</span>
                    {/*<span id='body-service-content'>{userInfo.parent.schoolExplain}</span>*/}
                    <span id='body-service-content'><div dangerouslySetInnerHTML={{ __html: schoolExplain }} /></span>

                    {/*信息费列表*/}
                    <span className='service-content-title'>信息费（元/年）</span>
                    <div style={{ marginTop: '6px' }}>{rechargeItems}</div>
                </div>
            </div>
        )
    }

    getServiceList = () => {
        const { schoolId, rechargeList, schoolContent, schoolExplain } = this.state
        rechargeList.length = 0

        fetchGet(API.INFO_CARD_SERVICE_LIST, {
            schoolId
        }).then(response => {
            Toast.hide()

            if (response && response.data && response.data.rulesList &&
                response.data.rulesList.length > 0) {
                this.setState({
                    rechargeList: response.data.rulesList,
                    schoolContent: response.data.schoolContent,
                    schoolExplain: response.data.schoolExplain,
                }, () => {
                    console.log(rechargeList)
                })
            }

        }).catch(error => {
            Toast.hide()

            this.setState({
                rechargeList,
            })
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    }

    onRechargeClick = (index, rid) => {
        this.wxPayRequest(rid)
    }

    wxPayRequest = (rid) => {
        const { id, appId, openId } = this.state
        let err = ''
        Toast.loading('')

        fetchPost(API.ELECTRONIC_CARD_ORDER, {
            appId: appId,
            openId: openId,
            studentId: id,
            rId: rid,
        }).then((response) => {
            Toast.hide()
            const data = response.data
            err = data
            if (err === undefined) {
                err = response.message;
            }
            if (typeof WeixinJSBridge == 'undefined') {
                if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady',
                        this.onBridgeReady(data), false)
                } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady',
                        this.onBridgeReady(data))
                    document.attachEvent('onWeixinJSBridgeReady',
                        this.onBridgeReady(data))
                }
            } else {
                this.onBridgeReady(data)
            }
        }).catch((error) => {
            console.log('error:' + JSON.stringify(error))
            Toast.show('支付失败！' + err)
        })
    }

    onBridgeReady = (json) => {
        console.log('json:', json)
        const that = this
        window.WeixinJSBridge.invoke(
            'getBrandWCPayRequest', JSON.parse(json),
            function (res) {
                if (res.err_msg == 'get_brand_wcpay_request:ok') {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    Toast.success('支付成功！')
                    // that.props.history.push('/payResult/' + that.state.amount)
                } else {
                    Toast.fail('支付失败！')
                    // message.info("支付失败:" + res.err_msg)
                    // that.setState({
                    //     payInfo: json,
                    //     payResult: "支付失败:" + JSON.stringify(res)
                    // });
                }
            })
    }

}

let mapStateToProps = (state) => ({
    userInfo: { ...state.redUserInfo },
    schoolId: state.redUserInfo.user.schoolId,
    stu: state.redUserInfo.parent.student,
    openId: state.redUserInfo.userOpenid,
    stuPhoto: state.redUserInfo.parent.student
        ? state.redUserInfo.parent.student.stuPhoto
        : '',
    stuName: state.redUserInfo.parent.student
        ? state.redUserInfo.parent.student.stuName
        : '',
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ServicePayCost)
